import BaseMixin from './base.mixin'
import { buildSuccessUploadStatusUrl } from '@/shared/utils/exam-attachment'

const mixin = {
  mixins: [
    BaseMixin
  ],
  methods: {
    getExamFileById (fileId, type = 'application/pdf') {
      return this.requestGetBlob(`/core/Administrator/Exams/File?examFileId=${fileId}`, type)
    },
    removeExamFile (fileId, examId) {
      const file = {
        fileId,
        examId
      }
      return this.requestDelete(`/core/Exams/RemoveExamFile`, file)
    },
    getSignedUrl (examId, md5, extension, fileType) {
      const url = '/core/Administrator/Exam/SignedUrl'
      return this.requestGet(`${url}?ExamId=${examId}&Md5=${md5}&Extension=${extension}&fileType=${fileType}`)
    },
    async getAttachmentTypes () {
      const response = await this.requestGet('/core/File/AttachmentType/GetAll')
      return response?.data || []
    },
    async uploadFile (file, signedUrl) {
      const type = file.type ? file.type : 'application/octet-stream'
      const config = {
        headers: {
          'Content-Type': type
        }
      }
      await this.requestPut(signedUrl, file, config)
    },
    SetSuccessUploadStatus (fileId, attachmentType) {
      return this.requestPut(buildSuccessUploadStatusUrl(fileId, attachmentType))
    }
  }
}

export default mixin
